module.exports = __webpack_public_path__ + "static/media/rahman-book.4942a133.PNG";